import {PC, Mobile} from "../../../../hooks/util/useMediaquery";

import LandingMobile from "./Mobile/main/landingMobile";
import LandingPC from "./PC/landingPc";

const Elem:React.FC<any> = () => {
  return (
    <>
      <PC>
        <LandingPC/>
      </PC>

      <Mobile>
        <LandingMobile />
      </Mobile>
    </>
  )
};

export default Elem;